// extracted by mini-css-extract-plugin
export default {"modal":"_35tEz","root":"Z4FrY","video":"e_MEF","iframe":"_3rsAb","close":"rN8Vr","closeIcon":"dYTfu"};